import { Component, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { GlobalSettingsService } from '../../../../../core/services/global-settings.service';
import { IllumPolygonCreatorService } from '../../../../../core/services/Illum-polygon-creator.service';
import { GlobeService } from '../../../../../core/services/globe.service';
import { PolygonDrawingHelper } from '../../../../../core/services/polygon-drawing-helper.service';
import * as Cesium from 'cesium';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-geofence-creation-button',
  standalone: true,
  imports: [],
  templateUrl: './geofence-creation-button.component.html',
  styleUrl: './geofence-creation-button.component.css'
})
export class GeofenceCreationButtonComponent implements OnInit, OnDestroy {
  @Output() done = new EventEmitter<number[][]>();
  @Output() cancel = new EventEmitter<void>();

  private polygonHelper: PolygonDrawingHelper | null = null;

  constructor(
    private illumPolygonCreator: IllumPolygonCreatorService,
    private globalSettings: GlobalSettingsService,
    private globeService: GlobeService,
  ) { }

  ngOnInit(): void {
    const viewer = this.globeService.getViewer();
    if (viewer) {
      this.polygonHelper = new PolygonDrawingHelper(viewer);
      this.polygonHelper.startDrawing();
    }
    this.illumPolygonCreator.startDrawing({
      callback: (polypositions: number[][]) => this.finishDrawing(polypositions)
    });
  }

  ngOnDestroy(): void {
    this.polygonHelper?.clear();
    this.illumPolygonCreator.stopDrawing();
  }

  finishDrawing(polypositions: number[][]) {
    this.polygonHelper?.finishDrawing();
    if (!polypositions || polypositions.length < 4) {
      this.illumPolygonCreator.stopDrawing();
      this.globalSettings.newGeofenceData = [];
      this.cancel.emit();
    } else {
      const cartographicPositions = polypositions.map(pos => {
        const cartesian = Array.isArray(pos)
          ? Cesium.Cartesian3.fromArray(pos)
          : pos;
        return radiansToDegreesNoHeight(
          Cesium.Ellipsoid.WGS84.cartesianToCartographic(cartesian), 0
        );
      });
      this.globalSettings.newGeofenceData = cartographicPositions;
      this.done.emit(cartographicPositions);
      this.illumPolygonCreator.stopDrawing();
    }
  }

  cancelDrawing() {
    this.polygonHelper?.clear();
    this.illumPolygonCreator.stopDrawing();
    this.cancel.emit();
  }

  finishDrawingFromButton() {
    const polypositions = this.illumPolygonCreator.getPolygon();
    this.polygonHelper?.finishDrawing();
    if (!polypositions || polypositions.length < 4) {
      this.illumPolygonCreator.stopDrawing();
      this.globalSettings.newGeofenceData = [];
      this.cancel.emit();
      return;
    }
    const cartographicPositions = polypositions.map((pos: any) => {
      const cartesian = Array.isArray(pos)
        ? Cesium.Cartesian3.fromArray(pos)
        : pos;
      return radiansToDegreesNoHeight(
        Cesium.Ellipsoid.WGS84.cartesianToCartographic(cartesian), 0
      );
    });
    this.globalSettings.newGeofenceData = cartographicPositions;
    this.done.emit(cartographicPositions);
    this.illumPolygonCreator.stopDrawing();
  }
}

function radiansToDegreesNoHeight(cartographic: any, height: number): number[] {
  return [
    cartographic.longitude * 180 / Math.PI,
    cartographic.latitude * 180 / Math.PI,
    height
  ];
}
